import { render, staticRenderFns } from "./SpaTangZhiYuan.vue?vue&type=template&id=7e9b67c1&scoped=true"
import script from "./SpaTangZhiYuan.vue?vue&type=script&lang=js"
export * from "./SpaTangZhiYuan.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/roomdetail.css?vue&type=style&index=0&id=7e9b67c1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9b67c1",
  null
  
)

export default component.exports